const envConfig = {
  local: {
    REACT_APP_ENV: 'local',
    REACT_APP_URL: 'http://localhost:3000',
    REACT_APP_ADMINURL: 'https://admin.dev-ctrl.cfahome.com/',
    REACT_CORE_API_URL: 'https://core.dev-ctrl.cfahome.com',
  },
  development: {
    REACT_APP_ENV: 'development',
    REACT_APP_URL: 'https://host.dev-ctrl.cfahome.com',
    REACT_APP_ADMINURL: 'https://admin.dev-ctrl.cfahome.com/',
    REACT_CORE_API_URL: 'https://core.dev-ctrl.cfahome.com',
  },
  test: {
    REACT_APP_ENV: 'test',
    REACT_APP_URL: 'https://host.test-ctrl.cfahome.com',
    REACT_APP_ADMINURL: 'https://admin.test-ctrl.cfahome.com/',
    REACT_CORE_API_URL: 'https://core.test-ctrl.cfahome.com',
  },
  beta: {
    REACT_APP_ENV: 'beta',
    REACT_APP_URL: 'https://host.beta-ctrl.cfahome.com',
    REACT_APP_ADMINURL: 'https://admin.ctrl.cfahome.com/',
    REACT_CORE_API_URL: 'https://core.ctrl.cfahome.com',
  },
  production: {
    REACT_APP_ENV: 'production',
    REACT_APP_URL: 'https://host.ctrl.cfahome.com',
    REACT_APP_ADMINURL: 'https://admin.ctrl.cfahome.com/',
    REACT_CORE_API_URL: 'https://core.ctrl.cfahome.com',
  },
};

export default envConfig;
